// extracted by mini-css-extract-plugin
module.exports = {"allLink":"_3JUx_te","allButton":"_2zJUI1Y","icon":"_2903hoC","right":"_3lHbIRB"};